import { isCar as checkIsCar, getVehicleMessageImageUrl } from '@/utils/helpers';
import type { TVehicleMessageConfig, TVehicleMessageLogicResult } from './vehicle-message.types';

/** Monta a URL da imagem e o link do anúncio do veículo na mensagem. */
export const useVehicleMessageLogic = ({
	vehicleType = 'Car',
	photoPath,
	advertiseId,
	advertiseUrl,
}: Pick<TVehicleMessageConfig, 'vehicleType' | 'photoPath' | 'advertiseId' | 'advertiseUrl'>): TVehicleMessageLogicResult => {
	const carFlag = checkIsCar(vehicleType);
	const imgSrc = getVehicleMessageImageUrl(photoPath, vehicleType);
	const oldAdUrl = `${import.meta.env.VITE_URL_PORTAL}/${carFlag ? 'c' : 'm'}/${advertiseId}`;
	const adUrl = advertiseUrl || oldAdUrl;

	return { isCar: carFlag, imgSrc, adUrl };
};
